import { createSelector } from 'reselect';
import { PagesWithDecisionsSelector, SelectedOfferNameSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
export var DecisionPagesViewModel = createSelector([SelectedOfferNameSelector, PagesWithDecisionsSelector], function (offerName, decisions) {
  return [{
    name: offerName,
    decisions: decisions
  }];
});